import type { CustomFormData, ApertureWidgetLoadCallback } from "./types.js";
import { SET_FORM_DATA_EVENT, FEEDBACK_WIDGET_LOAD_EVENT, FEEDBACK_WIDGET_CONTAINER_ID } from "./types.js";
const sendCustomFormOptionsEvent = (customFormData: CustomFormData) => {
  const setFormDataEvent = new CustomEvent(SET_FORM_DATA_EVENT, { detail: customFormData });
  document.dispatchEvent(setFormDataEvent);
};
/**
 * The method executes a callback function on aperture load.
 * Executes the callback if feedback container is already added to the page
 * Else listens to feedback-widget-load event and then executes the function
 * @param apertureWidgetLoadCallback callback function
 * @param function args
 */
export const onApertureWidgetLoad = (
  apertureWidgetLoadCallback: ApertureWidgetLoadCallback,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...args: any[]
) => {
  const widgetContainer = document.getElementById(FEEDBACK_WIDGET_CONTAINER_ID);
  if (widgetContainer) {
    apertureWidgetLoadCallback(...args);
  } else {
    document.addEventListener(FEEDBACK_WIDGET_LOAD_EVENT, () => {
      apertureWidgetLoadCallback(...args);
    });
  }
};
/**
 * The method sets custom form options for the aperture feedback form
 * @param cutomFormOptions
 */
export const setCustomFormOptions = (customFormData: CustomFormData) => {
  onApertureWidgetLoad(sendCustomFormOptionsEvent, customFormData);
};
